/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `ScheduledReport.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { ScheduledReport } from "./ScheduledReport";

import { CustomScheduledReport } from "./CustomScheduledReport";
import { Project } from "./Project";
import { RecipientList } from "./RecipientList";

export type format = "pdf" | "xlsx";
export type reportType = "past_due_imminent_action" | "a_e_report" | "custom";

export const formatValues = { pdf: 1, xlsx: 2 };
export const reportTypeValues = { past_due_imminent_action: 1, a_e_report: 2, custom: 3 };

export abstract class ScheduledReportModel {
    id: number;
    createdAt: Dayjs;
    enabled: boolean;
    format: format;
    frequency: string;
    name: string;
    projectId: number;
    recipientListId: number | null;
    reportType: reportType;
    updatedAt: Dayjs;
    customScheduledReport: CustomScheduledReport | null | undefined;
    project: Project | null | undefined;
    recipientList: RecipientList | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        createdAt: Dayjs,
        enabled: boolean,
        format: format,
        frequency: string,
        name: string,
        projectId: number,
        recipientListId: number | null,
        reportType: reportType,
        updatedAt: Dayjs,
        customScheduledReport: CustomScheduledReport | null | undefined,
        project: Project | null | undefined,
        recipientList: RecipientList | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.enabled = enabled;
        this.format = format;
        this.frequency = frequency;
        this.name = name;
        this.projectId = projectId;
        this.recipientListId = recipientListId;
        this.reportType = reportType;
        this.updatedAt = updatedAt;
        this.customScheduledReport = customScheduledReport;
        this.project = project;
        this.recipientList = recipientList;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): ScheduledReport {
        const newObject = new ScheduledReport(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["enabled"],
            json["format"],
            json["frequency"],
            json["name"],
            json["project_id"],
            json["recipient_list_id"],
            json["report_type"],
            dayjs(json["updated_at"]).tz(timezone),
            json["custom_scheduled_report"] == null
                ? json["custom_scheduled_report"]
                : CustomScheduledReport.fromApiObject(json["custom_scheduled_report"], timezone),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone),
            json["recipient_list"] == null
                ? json["recipient_list"]
                : RecipientList.fromApiObject(json["recipient_list"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            created_at: this.createdAt,
            enabled: this.enabled,
            format: this.format,
            frequency: this.frequency,
            name: this.name,
            project_id: this.projectId,
            recipient_list_id: this.recipientListId,
            report_type: this.reportType,
            updated_at: this.updatedAt,
            custom_scheduled_report_attributes: this.customScheduledReport?.toApiObject(visited),
            project_attributes: this.project?.toApiObject(visited),
            recipient_list_attributes: this.recipientList?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): ScheduledReport {
        const clone = Object.create(this) as ScheduledReport;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
